// extracted by mini-css-extract-plugin
export default {"docs":"Docs_docs__rgVF4","icon":"Docs_icon__tIix5","iconGreen":"Docs_iconGreen__30bmz","button":"Docs_button__bUU8X"};